/*
This handler detects when a user comes via a URL with a code therein, and then hides the disocunt code input to prevent overwriting promo discounts / clashing combo discounts / free gift codes in conjunction with other promos
*/

window.URLDiscountManager = (function () {
  let debug = false;
  let pendingURLTagRemovalCode = null;

  function log(...args) {
    if (debug) {
      console.log('[URLDiscountManager]', ...args);
    }
  }

  function getURLDiscountCode() {
    const cookies = document.cookie.split(';');
    const discountCookie = cookies.find(c => c.trim().startsWith('discount_code='));

    if (!discountCookie) return null;

    const value = decodeURIComponent(discountCookie.split('=')[1] || '').trim();
    return value && value !== 'undefined' ? value.toUpperCase() : null;
  }

  function hasURLDiscount() {
    return Boolean(getURLDiscountCode());
  }

  function clearURLDiscountCookie() {
    document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    log('Cleared URL discount cookie');
  }

  function removeLegacyNotice() {
    const notice = document.getElementById('url-discount-notice');
    if (notice) {
      notice.remove();
      log('Removed legacy URL discount notice');
    }
  }

  function setDiscountDisclosureState(discountInputWrapper, isLocked) {
    // Older versions hid the whole Rebuy component. Clear that inline style so
    // the applied tag and discount amount can remain visible.
    if (discountInputWrapper.style.display) {
      discountInputWrapper.style.removeProperty('display');
    }

    const disclosure = discountInputWrapper.querySelector(
      '.rebuy-cart__discount-disclosure'
    );
    if (!disclosure) {
      log('Discount disclosure not found yet');
      return;
    }

    const summary = disclosure.querySelector('.rebuy-cart__discount-summary');
    const label = disclosure.querySelector('.rebuy-cart__discount-summary-label');
    const arrow = disclosure.querySelector('.rebuy-cart__discount-summary-arrow');

    if (isLocked) {
      if (label && !disclosure.dataset.urlDiscountOriginalLabel) {
        disclosure.dataset.urlDiscountOriginalLabel = label.textContent.trim();
      }

      disclosure.classList.add('bwb-cart__discount-disclosure--url-locked');
      if (disclosure.hasAttribute('open')) {
        disclosure.removeAttribute('open');
      }

      if (label && label.textContent !== '¡CÓDIGO DE DESCUENTO APLICADO!') {
        label.textContent = '¡CÓDIGO DE DESCUENTO APLICADO!';
      }

      if (summary) {
        summary.setAttribute('aria-disabled', 'true');
        summary.tabIndex = -1;
      }

      // Rebuy can apply its own arrow display style after a Smart Cart redraw,
      // so use an inline important declaration as the final lock.
      if (
        arrow &&
        (arrow.style.getPropertyValue('display') !== 'none' ||
          arrow.style.getPropertyPriority('display') !== 'important')
      ) {
        arrow.style.setProperty('display', 'none', 'important');
      }

      log('Locked discount disclosure');
      return;
    }

    disclosure.classList.remove('bwb-cart__discount-disclosure--url-locked');

    if (label && disclosure.dataset.urlDiscountOriginalLabel) {
      label.textContent = disclosure.dataset.urlDiscountOriginalLabel;
      delete disclosure.dataset.urlDiscountOriginalLabel;
    }

    if (summary) {
      summary.removeAttribute('aria-disabled');
      summary.removeAttribute('tabindex');
    }

    if (arrow?.style.getPropertyValue('display')) {
      arrow.style.removeProperty('display');
    }

    log('Restored discount disclosure');
  }

  function attachDisclosureObserver(discountInputWrapper) {
    if (discountInputWrapper._urlDiscountDisclosureObserver) return;

    const observer = new MutationObserver(() => {
      if (hasURLDiscount()) {
        setDiscountDisclosureState(discountInputWrapper, true);
      }
    });

    // Rebuy can replace the disclosure when it redraws the Smart Cart, so
    // observe the container rather than a single disclosure instance.
    observer.observe(discountInputWrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'open'],
    });
    discountInputWrapper._urlDiscountDisclosureObserver = observer;
    log('Disclosure observer attached');
  }

  function detachDisclosureObserver(discountInputWrapper) {
    const observer = discountInputWrapper._urlDiscountDisclosureObserver;
    if (!observer) return;

    observer.disconnect();
    delete discountInputWrapper._urlDiscountDisclosureObserver;
    log('Disclosure observer removed');
  }

  function hasVisibleURLDiscountTag(code) {
    return Array.from(document.querySelectorAll('.rebuy-cart__discount-tag-text')).some(tag => {
      return tag.textContent.trim().toUpperCase() === code;
    });
  }

  function trackURLTagRemoval(event) {
    const removeButton = event.target.closest('.rebuy-cart__discount-tag-remove');
    if (!removeButton) return;

    const tag = removeButton.closest('.rebuy-cart__discount-tag');
    const tagCode = tag
      ?.querySelector('.rebuy-cart__discount-tag-text')
      ?.textContent.trim()
      .toUpperCase();
    const urlCode = getURLDiscountCode();

    if (tagCode && urlCode && tagCode === urlCode) {
      pendingURLTagRemovalCode = urlCode;
      log('Tracked URL discount tag removal:', urlCode);
    }
  }

  function handleDiscountRemoved() {
    if (pendingURLTagRemovalCode) {
      const removedCode = pendingURLTagRemovalCode;
      pendingURLTagRemovalCode = null;

      if (!hasVisibleURLDiscountTag(removedCode)) {
        clearURLDiscountCookie();
      }
    }

    manageDiscountInput();
  }

  function manageDiscountInput() {
    log('=== manageDiscountInput called ===');

    removeLegacyNotice();

    const discountInputWrapper = document.querySelector('[data-rebuy-component="discount-input"]');
    if (!discountInputWrapper) {
      log('Input wrapper not found yet');
      return;
    }

    const hasURL = hasURLDiscount();
    log('Has URL discount:', hasURL);

    if (hasURL) {
      setDiscountDisclosureState(discountInputWrapper, true);
      attachDisclosureObserver(discountInputWrapper);
    } else {
      setDiscountDisclosureState(discountInputWrapper, false);
      detachDisclosureObserver(discountInputWrapper);
    }
  }

  return {
    init: function () {
      if (!window.RebuyEventManager) {
        console.error('[URLDiscountManager] RebuyEventManager not available');
        return this;
      }

      window.RebuyEventManager.on('cart:show', manageDiscountInput)
        .on('cart:change', manageDiscountInput)
        .on('cart:ready', manageDiscountInput)
        .on('discount:removed', handleDiscountRemoved);

      document.addEventListener('click', trackURLTagRemoval);

      window.addEventListener('pageshow', manageDiscountInput);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          manageDiscountInput();
        }
      });

      log('Initialized');
      return this;
    },

    refresh: function () {
      manageDiscountInput();
      return this;
    },

    debug: function (enabled) {
      debug = enabled;
      log('Debug logging', enabled ? 'enabled' : 'disabled');
      return this;
    },
  };
})();
